import React from 'react';
import { Box, Text, Group, Anchor } from '@mantine/core';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      component="footer"
      style={{
        background: '#2c2c2c',
        color: 'white',
        padding: 'clamp(1.5rem, 4vw, 3rem) clamp(1rem, 4vw, 2rem) clamp(1rem, 3vw, 2rem)',
        textAlign: 'center',
        width: '100%',
      }}
    >
      {/* Links Row */}
      <Group
        justify="center"
        gap={{ base: 'xs', sm: 'md' }}
        mb="md"
        wrap="nowrap"
      >
        <Anchor
          component={Link}
          to="/privacy"
          style={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 'clamp(0.75rem, 2.5vw, 0.85rem)',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={(e) => {
            e.target.style.color = 'var(--primary-gold)';
            e.target.style.textDecoration = 'underline';
          }}
          onMouseLeave={(e) => {
            e.target.style.color = 'rgba(255, 255, 255, 0.7)';
            e.target.style.textDecoration = 'none';
          }}
        >
          Privacy Policy
        </Anchor>
        <Text
          style={{
            color: 'rgba(255, 255, 255, 0.4)',
            fontSize: 'clamp(0.75rem, 2.5vw, 0.85rem)',
            margin: 0,
          }}
        >
          •
        </Text>
        <Anchor
          component={Link}
          to="/terms"
          style={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 'clamp(0.75rem, 2.5vw, 0.85rem)',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={(e) => {
            e.target.style.color = 'var(--primary-gold)';
            e.target.style.textDecoration = 'underline';
          }}
          onMouseLeave={(e) => {
            e.target.style.color = 'rgba(255, 255, 255, 0.7)';
            e.target.style.textDecoration = 'none';
          }}
        >
          Terms of Service
        </Anchor>
        <Text
          style={{
            color: 'rgba(255, 255, 255, 0.4)',
            fontSize: 'clamp(0.75rem, 2.5vw, 0.85rem)',
            margin: 0,
          }}
        >
          •
        </Text>
        <Anchor
          component={Link}
          to="/contact"
          style={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 'clamp(0.75rem, 2.5vw, 0.85rem)',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={(e) => {
            e.target.style.color = 'var(--primary-gold)';
            e.target.style.textDecoration = 'underline';
          }}
          onMouseLeave={(e) => {
            e.target.style.color = 'rgba(255, 255, 255, 0.7)';
            e.target.style.textDecoration = 'none';
          }}
        >
          Contact
        </Anchor>
      </Group>

      {/* Copyright */}
      <div style={{ textAlign: 'center', width: '100%' }}>
        <Text
          style={{
            color: 'rgba(255, 255, 255, 0.6)',
            fontSize: 'clamp(0.7rem, 2.2vw, 0.85rem)',
            margin: 0,
            display: 'inline-block',
          }}
        >
          © {new Date().getFullYear()} Prix du Canada. All rights reserved.
        </Text>
      </div>
    </Box>
  );
};

export default Footer;
